module.exports = __webpack_public_path__ + "fonts/9f5000a44a68bee78e0703960035e7db.svg";